<template>
    <v-row>
        <v-col
                cols="12"
                md="6"
        >
            <v-text-field
                    v-model="filters.store_name"
                    label="Nom"
            ></v-text-field>
        </v-col>
        <v-col
                cols="12"
                md="6"
        >
            <v-text-field
                    v-model="filters.store_email"
                    label="Email"
            ></v-text-field>
        </v-col>
    </v-row>
</template>

<script>
    import {debounce} from "../../../helpers/debounce";

    export default {
        name: 'StoresFilters.vue',
        data() {
            return {
                filters: {
                    store_name: '',
                    store_email: '',
                },
            }
        },
        methods: {

        },
        computed: {

        },
        watch: {
            filters: {
                handler: debounce(function (value) {
                    this.$emit('onStoreFiltersChanged', value);
                }, 500),
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
